<template>
  <div>
    <div class="title mb-2">
      請告訴我這件商品是什麽？
    </div>

    <div
      v-if="parcelDetail && parcelDetail.isStorage && parcelDetail.extraInfo.snapshots"
      class="mb-2"
    >
      <v-layout>
        <div class="mr-4">
          <KImg
            :src="parcelDetail.extraInfo.snapshots[0] | upyun('!/fh/80')"
            width="80"
          />
        </div>
        <div>
          <div class="grey--text">
            <span class="blue--text mr-2">{{ parcelDetail.weight | toKg }} KG</span>
            <br>
            {{ parcelDetail.createdAt }}
          </div>
        </div>
      </v-layout>
    </div>

    <v-layout>
      <v-text-field
        v-model="goodsUrl"
        :disabled="disabled"
        :rules="[$store.state.validationRules.required]"
        :loading="fetchGoodsLoading"
        autofocus
        label="請輸入淘寶商品網址"
        @keyup.enter="startFetchGoods()"
      />
      <div
        v-if="!$store.state.installedCrx"
        class="body-1 orange--text pa-2"
      >
        安裝
        <a
          class="down-link"
          href="https://chrome.google.com/webstore/detail/%E5%B7%A7%E5%B7%A7%E9%83%8E%E5%8C%85%E8%A3%B9%E7%AE%A1%E5%AE%B6/lacejchmbljdoaimkbmcflcechgndbim"
          target="_blank"
        >巧巧郎的鑰匙</a>
        開啟該功能
      </div>
      <v-btn
        v-else
        :disabled="!goodsUrl"
        :loading="fetchGoodsLoading"
        class="info"
        @click="startFetchGoods()"
      >
        獲取商品信息
      </v-btn>
    </v-layout>

    <!-- 切换到图片搜索或关键字搜索 -->
    <div class="text-center mt-2">
      <v-btn
        flat
        color="primary"
        class="ml-1"
        @click="$emit('change-input-type', 'goodsSearch')"
      >
        <u>使用關鍵字查詢</u>
      </v-btn>
    </div>

    <div v-if="showFetchGoodsTips">
      <img
        src="../images/AttachTrackingNo-itemTips.jpg"
        style="width:100%"
      >
    </div>

    <div v-if="goodsData">
      <v-layout
        v-for="(item,index) in goodsData.items"
        :key="index"
      >
        <div class="mr-4">
          <img
            :src="item.itemPic"
            width="80"
          >
        </div>
        <div>
          {{ item.itemName }}
          <v-layout align-center>
            <div
              style="width:50px"
              class="mr-4"
            >
              <v-text-field
                v-model="item.itemQty"
                :rules="[$store.state.validationRules.required]"
                label="數量"
                type="number"
              />
            </div>
            <div class="grey--text">
              手動登記包裹不免費保價
            </div>
          </v-layout>
        </div>
      </v-layout>

      <div v-if="showFirbidText">
        <v-alert
          :value="true"
          type="warning"
          border="left"
          elevation="1"
          colored-border
          class="body-2 mt-4 "
        >
          以下商品無法進行包裹登記 <small>(商品非實際貨物 例如：一元拍，補差價，運費等)</small>
        </v-alert>
        <img
          src="../images/AttachTrackingNo-firbid.jpg"
          style="width: 100%"
        >
      </div>
    </div>
  </div>
</template>

<script>
import { createProductSearchService } from '@g/utils/productSearchService'

export default {
  props: {
    parcel: {
      type: Object,
      default: null
    },
    trackingNo: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loadingSubmit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      goodsUrl: '',
      goodsData: null,
      fetchGoodsLoading: false,
      showFetchGoodsTips: !localStorage.successFetchGoods,
      searchService: null
    }
  },
  computed: {
    parcelDetail () {
      return this.$store.state.parcel.list.find(item => item.trackingNo === this.trackingNo)
    },
    showFirbidText () {
      if (this.goodsData && this.goodsData.items.length) {
        const name = this.goodsData.items[0].itemName

        return ['一元拍', '补差价', '运费', '集运'].find(str => name.indexOf(str) > -1)
      }
      return false
    }
  },
  created () {
    // 初始化搜索服务
    this.searchService = createProductSearchService(this.$store)
  },
  methods: {
    async startFetchGoods () {
      if (!/^https?:\/\/.+/.test(this.goodsUrl)) {
        this.showFetchGoodsTips = true
        this.$snackbar('請輸入正確的商品網站', { color: 'red' })
        return
      }
      if (this.goodsUrl.indexOf('1688.com') > -1) {
        this.$snackbar('不支持1688商品網站', { color: 'red' })
        return
      }
      try {
        this.fetchGoodsLoading = true

        // 使用统一服务获取商品详情
        const data = await this.searchService.fetchItemByUrl(this.goodsUrl)

        let item
        // 判断是1688还是淘宝商品
        if (data.catalog || data.tpCatalog) {
          // 淘宝商品，从返回的数据中提取商品信息
          item = {
            itemid: data.item?.itemid || data.itemid,
            itemName: data.item?.itemName || data.itemName,
            itemCid: data.item?.itemCid || data.itemCid,
            itemFinalPrice: data.item?.itemFinalPrice || data.itemFinalPrice,
            itemPic: data.item?.itemPic || data.itemPic,
            traSellerId: data.item?.traSellerId || data.traSellerId,
            traSellerName: data.item?.traSellerName || data.traSellerName,
            platform: 'taobao'
          }
        } else if (data.item) {
          // 1688商品
          item = {
            ...data.item,
            platform: '1688'
          }
        }

        if (item) {
          this.goodsData = {
            items: [item],
            traAmount: item.itemFinalPrice
          }
          this.showFetchGoodsTips = false
          this.$emit('goods-fetched', this.goodsData)
        }
      } catch (error) {
        console.error('获取商品信息失败:', error)
        this.$snackbar(error.message || '獲取商品信息失敗', { color: 'red' })
      } finally {
        this.fetchGoodsLoading = false
      }
    }
  }
}
</script>
